import { useEffect, useState } from "react";
import { Auditores, Hallazgo, InformeAI, Personal } from "../../interfaces/PlanesInterface"
import { Users } from "../../interfaces/UserInterface";
import { API_AUDITORIAS } from "../../features/constants";
import { Alerta, Confirm, Toast } from "../../features/toast";
import "../../App";
import { error } from "console";

interface InformeAIProps{
    informe: InformeAI | undefined
    update: Boolean 
    setUpdate: React.Dispatch<React.SetStateAction<boolean>>
    setInformeSelect?: React.Dispatch<React.SetStateAction<InformeAI | undefined>>
}

export const InformeAuditoriaInterna = ({informe,update,setUpdate,setInformeSelect}:InformeAIProps)=>{
    
    let localUser = localStorage.getItem("localUser");
    let user:Users = localUser?JSON.parse(localUser):undefined;

    const [auditores, setAuditores] = useState<Auditores[]>([]);
    const [personal, setPersonal] = useState<Personal[]>([]);
    const [fortalezas, setFortalezas] = useState<Hallazgo[]>([]);
    const [oportunidades, setOportunidades] = useState<Hallazgo[]>([]);
    const [observaciones, setObservaciones] = useState<Hallazgo[]>([]);
    const [noConformidades, setNoConformidades] = useState<Hallazgo[]>([]);
    const [actualizar, setActualizar] = useState(false);

    const [organizacion, setOrganizacion] = useState("");
    const [direccion, setDireccion] = useState("");
    const [fecha, setFecha] = useState("");
    const [numero_auditoria, setNumero_auditoria] = useState("");
    const [objetivo, setObjetivo] = useState("");
    const [alcance, setAlcance] = useState("");
    const [criterios, setCriterios] = useState("");
    const [documentos_asociados, setDocumentos_asociados] = useState("");
    const [conclusion, setConclusion] = useState("");

    const [nombreNuevoAuditor, setNombreNuevoAuditor] = useState("");
    const [funcionNuevoAuditor, setFuncionNuevoAuditor] = useState("");

    const [nombreNuevoPersonal, setNombreNuevoPersonal] = useState("");
    const [puestoNuevoPersonal, setPuestoNuevoPersonal] = useState("");

    const [numeroFortalezaNuevo, setNumeroFortalezaNuevo] = useState("");
    const [descripcionFortalezaNuevo, setDescripcionFortalezaNuevo] = useState("");
    const [normaFortalezaNuevo, setNormaFortalezaNuevo] = useState("");

    const [numeroOportunidadNuevo, setNumeroOportunidadNuevo] = useState("");
    const [descripcionOportunidadNuevo, setDescripcionOportunidadNuevo] = useState("");
    const [normaOportunidadNuevo, setNormaOportunidadNuevo] = useState("");

    const [numeroObservacionNuevo, setNumeroObservacionNuevo] = useState("");
    const [descripcionObservacionNuevo, setDescripcionObservacionNuevo] = useState("");
    const [normaObservacionNuevo, setNormaObservacionNuevo] = useState("");

    const [numeroNoConformidadNuevo, setNumeroNoConformidadNuevo] = useState("");
    const [descripcionNoConformidadNuevo, setDescripcionNoConformidadNuevo] = useState("");
    const [normaNoConformidadNuevo, setNormaNoConformidadNuevo] = useState("");


    useEffect(()=>{
        if(informe && informe.Id !== ""){
            setOrganizacion(informe.Organizacion.toString());
            setDireccion(informe.Direccion.toString());
            setFecha(informe.Fecha.toString());
            setNumero_auditoria(informe.Nro_auditoria.toString());
            setObjetivo(informe.Objetivo.toString());
            setAlcance(informe.Alcance.toString());
            setCriterios(informe.Criterios.toString());
            setDocumentos_asociados(informe.Documentos_asociados.toString());
            setConclusion(informe.Conclusion.toString());
        }else{
            setOrganizacion("");
            setDireccion("");
            setFecha("");
            setNumero_auditoria("");
            setObjetivo("");
            setAlcance("");
            setCriterios("");
            setDocumentos_asociados("");
            setConclusion("");
        }
    },[informe]);

    useEffect(()=>{
        //buscar los auditores , el personal interviniente y los hallazgos en las bases de datos
        let init = {
            method: "POST",
            body: JSON.stringify({
                Id: informe?.Id
            }),
            header:{
                "Content-Type":"aplication/json"
            }
        };
        fetch(API_AUDITORIAS + "/Lista-de-Auditores-Informe",init)
            .then(response=>response.json())
            .catch(err=>console.log(err))
            .then((data:Auditores[])=>{
                setAuditores(data);
            })
        
        fetch(API_AUDITORIAS + "/Lista-Personal-Informe",init)
            .then(resp=>resp.json())
            .catch(error=>console.log(error))
            .then((personal:Personal[])=>{
                setPersonal(personal);
            })

        fetch(API_AUDITORIAS + "/Lista-Fortalezas",init)
            .then(response=>response.json())
            .catch(error=>console.log(error))
            .then((Fortalezas:Hallazgo[])=>{
                setFortalezas(Fortalezas);
            })

        fetch(API_AUDITORIAS + "/Lista-Oportunidades",init)
            .then(response=>response.json())
            .catch(error=>console.log(error))
            .then((Oportunidades:Hallazgo[])=>{
                setOportunidades(Oportunidades);
            })

        fetch(API_AUDITORIAS + "/Lista-Observaciones",init)
            .then(response=>response.json())
            .catch(error=>console.log(error))
            .then((Observaciones:Hallazgo[])=>{
                setObservaciones(Observaciones);
            })

        fetch(API_AUDITORIAS + "/Lista-NoConformidades",init)
            .then(response=>response.json())
            .catch(error=>console.log(error))
            .then((NoConformidades:Hallazgo[])=>{
                setNoConformidades(NoConformidades);
            })
        
    },[informe?.Id,actualizar])

    const nuevoAuditor = ()=>{
        let aud = {
            Id : "",
            Id_Informe: "",
            Nombre: "",
            Funcion: ""
        }
        setAuditores([...auditores,aud])
    }

    const guardarAuditor = ()=>{//Guarda los datos del auditor en la base de datos
        let init = {
            method: "POST",
            body: JSON.stringify({
                Id_Informe: informe?.Id,
                Nombre: nombreNuevoAuditor,
                Funcion: funcionNuevoAuditor
            }),
            header:{
                "Content-Type":"aplication/json"
            }
        };
        fetch(API_AUDITORIAS + "/Agregar-Auditor-Informe",init)
            .then(response=>response.json())
            .catch(err=>console.log(err))
            .then((data)=>{
                if(data?.Id){
                    Toast.fire({
                        icon:"success",
                        title:"Auditor Agregado",
                        text:"Se agrego el auditor correctamente"
                    })
                    setActualizar(!actualizar);
                    setNombreNuevoAuditor("");
                    setFuncionNuevoAuditor("");
                }else{
                    Toast.fire({
                        icon:"error",
                        title:"Error al Agregar el Auditor",
                        text:"No se pudo agregar el auditor"
                    })
                }
            })
    }

    const eliminarAuditor = (id:string)=>{//Elimina el auditor que ya esta guardado en la base de datos
        Confirm.fire({
            icon:"question",
            title:"Eliminar Auditor",
            text:"¿Desea Eliminar el Auditor Seleccionado?",
            confirmButtonText:"Eliminar",
            confirmButtonColor:"red"
        }).then(response=>{
            if(response.value === true){
                let init = {
                    method: "DELETE",
                    body: JSON.stringify({
                        Id: id
                    }),
                    header:{
                        "Content-Type":"aplication/json"
                    }
                };
                fetch(API_AUDITORIAS + "/Eliminar-Auditor-Informe",init)
                    .then(response=>response.json())
                    .catch(err=>console.log(err))
                    .then((data)=>{
                        if(data?.Mensaje ==="Ok"){
                            Toast.fire({
                                icon:"success",
                                title:"Auditor Eliminado",
                                text:"Se elimino el auditor correctamente"
                            })
                            setActualizar(!actualizar);
                            setNombreNuevoAuditor("");
                            setFuncionNuevoAuditor("");
                        }else{
                            Toast.fire({
                                icon:"error",
                                title:"Error al Eliminar el Auditor",
                                text:"No se pudo eliminar el auditor"
                            })
                        }
                    })
                    }
        })
        
    }
    const cancelarNuevoAuditor = ()=>{//Descarta los datos del auditor que aun no se guardo en la base de datos
        setNombreNuevoAuditor("");
        setFuncionNuevoAuditor("");
        setAuditores(auditores.slice(0,auditores.length-1));
    }
/////////////

    const nuevoPersonal = ()=>{
        let persona = {
            Id : "",
            Id_Informe: "",
            Nombre: "",
            Puesto: ""
        }
        setPersonal([...personal,persona]);
    }


    const cancelarNuevoPersonal = ()=>{//Descarta los datos del Personal que aun no se guardo en la base de datos
        setNombreNuevoPersonal("");
        setPuestoNuevoPersonal("");
        setPersonal(personal.slice(0,personal.length-1));
    }

    const guardarPersonal = ()=>{//Guarda los datos del personal en la base de datos
        let init = {
            method: "POST",
            body: JSON.stringify({
                Id_Informe: informe?.Id,
                Nombre: nombreNuevoPersonal,
                Puesto: puestoNuevoPersonal
            }),
            header:{
                "Content-Type":"aplication/json"
            }
        };
        fetch(API_AUDITORIAS + "/Agregar-Personal-Informe",init)
            .then(response=>response.json())
            .catch(err=>console.log(err))
            .then((data)=>{
                if(data?.Id){
                    Toast.fire({
                        icon:"success",
                        title:"Personal Agregado",
                        text:"Se agrego el Personal correctamente"
                    })
                    setActualizar(!actualizar);
                    setNombreNuevoPersonal("");
                    setPuestoNuevoPersonal("");
                }else{
                    Toast.fire({
                        icon:"error",
                        title:"Error al Agregar el Personal",
                        text:"No se pudo agregar el Personal"
                    })
                }
            })
    }

    const eliminarPersonal = (id:string)=>{//Elimina el personal que ya esta guardado en la base de datos
        Confirm.fire({
            icon:"question",
            title:"Eliminar Personal",
            text:"¿Desea Eliminar el Personal Seleccionado?",
            confirmButtonText:"Eliminar",
            confirmButtonColor:"red"
        }).then(response=>{
            if(response.value === true){
                let init = {
                    method: "DELETE",
                    body: JSON.stringify({
                        Id: id
                    }),
                    header:{
                        "Content-Type":"aplication/json"
                    }
                };
                fetch(API_AUDITORIAS + "/Eliminar-Personal-Informe",init)
                    .then(response=>response.json())
                    .catch(err=>console.log(err))
                    .then((data)=>{
                        if(data?.Mensaje ==="Ok"){
                            Toast.fire({
                                icon:"success",
                                title:"Personal Eliminado",
                                text:"Se elimino el Personal correctamente"
                            })
                            setActualizar(!actualizar);
                            setNombreNuevoPersonal("");
                            setPuestoNuevoPersonal("");
                        }else{
                            Toast.fire({
                                icon:"error",
                                title:"Error al Eliminar el Personal",
                                text:"No se pudo eliminar el Personal"
                            })
                        }
                    })
                    }
        })
        
    }


    const guardarInforme = ()=>{
        //envía los datos del informe a la base de datos
        let informeActual:InformeAI = {
                Id: informe?informe.Id:"",
                Organizacion: organizacion,
                Direccion: direccion,
                Fecha: fecha,
                Nro_auditoria: numero_auditoria,
                Objetivo: objetivo,
                Alcance: alcance,
                Criterios: criterios,
                Documentos_asociados: documentos_asociados,
                Conclusion: conclusion
            }
        let init = {
            method: informe?.Id===""?"POST":"PUT",
            body: JSON.stringify(informeActual),
            header:{
                "Content-Type":"aplication/json"
            }
        };
        fetch(API_AUDITORIAS + "/Informe-Auditoria-Interna",init)
            .then(response=>response.json())
            .catch(err=>console.log(err))
            .then((data)=>{
                if(data?.Mensaje === "Ok"){
                    Toast.fire({
                        icon:"success",
                        title:"Informe de Auditoría Interna",
                        text:"Datos Actualizados Correctamente"
                    })
                    setActualizar(!actualizar);
                    setUpdate(!update);
                    if (setInformeSelect){
                        setInformeSelect(informeActual);
                    }
                }else{
                    Toast.fire({
                        icon:"error",
                        title:"Informe de Auditoría Interna",
                        text:"No se logró actualizar los datos"
                    })
                }
            })
    }



    const eliminarInforme = (id:string)=>{
        Confirm.fire({
            icon:"question",
            title:"Eliminar Informe de Auditoría Interna",
            text:"¿Desea Eliminar de manera Permanente el Informe de Auditoría?",
            confirmButtonText:"Eliminar",
            confirmButtonColor:"red"
        }).then(response=>{
            if(response.value === true){
                let init = {
                    method: "DELETE",
                    body: JSON.stringify({
                        Id: id
                    }),
                    header:{
                        "Content-Type":"aplication/json"
                    }
                };
                fetch(API_AUDITORIAS + "/Informe",init)
                    .then(response=>response.json())
                    .catch(err=>console.log(err))
                    .then((data)=>{
                        if(data?.Mensaje ==="Ok"){
                            Toast.fire({
                                icon:"success",
                                title:"Informe de Auditoría Interna Eliminado",
                                text:"Se elimino correctamente el Informe de auditoría"
                            })
                            if(setInformeSelect)
                                setInformeSelect(undefined);
                            setUpdate(!update);
                        }else{
                            Toast.fire({
                                icon:"error",
                                title:"Error al Eliminar el Informe de Auditoría Interna",
                                text:"No se pudo eliminar el Informe de auditoría Interna"
                            })
                        }
                    })
            }
        })
    }
//* FORTALEZAS */

    const nuevaFortaleza = ()=>{
        let fort = {
            Id:"",
            Id_informe: "",
            Numero: "",
            Descripcion: "",
            Norma:""
        }
        setFortalezas([...fortalezas,fort]);
    }

    const cancelarNuevaFortaleza = ()=>{
        setNumeroFortalezaNuevo("");
        setDescripcionFortalezaNuevo("");
        setNormaFortalezaNuevo("");
        setFortalezas(fortalezas.slice(0,fortalezas.length-1));
    }

    const guardarFortaleza = ()=>{
        let init = {
            method: "POST",
            body: JSON.stringify({
                Id_informe: informe?.Id,
                Numero: numeroFortalezaNuevo,
                Descripcion: descripcionFortalezaNuevo,
                Norma: normaFortalezaNuevo
            }),
            header:{
                "Content-Type":"aplication/json"
            }
        };
        fetch(API_AUDITORIAS + "/Fortalezas",init)
            .then(response=>response.json())
            .catch(err=>console.log(err))
            .then((data)=>{
                if(data?.Id){
                    Toast.fire({
                        icon:"success",
                        title:"Fortaleza Agregada",
                        text:"Se agrego la Fortaleza correctamente"
                    })
                    setActualizar(!actualizar);
                    setNumeroFortalezaNuevo("");
                    setDescripcionFortalezaNuevo("");
                    setNormaFortalezaNuevo("");
                }else{
                    Toast.fire({
                        icon:"error",
                        title:"Error al Agregar la Fortaleza",
                        text:"No se pudo agregar la Fortaleza"
                    })
                }
            })
    }

    const eliminarFortaleza = (id:string)=>{
        Confirm.fire({
            icon:"question",
            title:"Eliminar Fortaleza",
            text:"¿Desea Eliminar la Fortaleza Seleccionada?",
            confirmButtonText:"Eliminar",
            confirmButtonColor:"red"
        }).then(response=>{
            if(response.value === true){

                let init = {
                    method: "DELETE",
                    body: JSON.stringify({
                        Id: id
                    }),
                    header:{
                        "Content-Type":"aplication/json"
                    }
                };
                fetch(API_AUDITORIAS + "/Fortalezas",init)
                    .then(response=>response.json())
                    .catch(err=>console.log(err))
                    .then((data)=>{
                        if(data?.Mensaje ==="Ok"){
                            Toast.fire({
                                icon:"success",
                                title:"Fortaleza Eliminada",
                                text:"Se elimino la Fortaleza correctamente"
                            })
                            setActualizar(!actualizar);
                            setNumeroFortalezaNuevo("");
                            setDescripcionFortalezaNuevo("");
                            setNormaFortalezaNuevo("");
                        }else{
                            Toast.fire({
                                icon:"error",
                                title:"Error al Eliminar la Fortaleza",
                                text:"No se pudo eliminar la Fortaleza"
                            })
                        }
                    })


            }
        })
    }

    //* OPORTUNIDADES */

    
    const nuevaOportunidad = ()=>{
        let op = {
            Id:"",
            Id_informe: "",
            Numero: "",
            Descripcion: "",
            Norma:""
        }
        setOportunidades([...oportunidades,op]);
    }

    const cancelarNuevaOportunidad = ()=>{
        setNumeroOportunidadNuevo("");
        setDescripcionOportunidadNuevo("");
        setNormaOportunidadNuevo("");
        setOportunidades(oportunidades.slice(0,oportunidades.length-1));
    }

    const guardarOportunidad = ()=>{
        let init = {
            method: "POST",
            body: JSON.stringify({
                Id_informe: informe?.Id,
                Numero: numeroOportunidadNuevo,
                Descripcion: descripcionOportunidadNuevo,
                Norma: normaOportunidadNuevo
            }),
            header:{
                "Content-Type":"aplication/json"
            }
        };
        fetch(API_AUDITORIAS + "/Oportunidades",init)
            .then(response=>response.json())
            .catch(err=>console.log(err))
            .then((data)=>{
                if(data?.Id){
                    Toast.fire({
                        icon:"success",
                        title:"Oportunidad de Mejora Agregada",
                        text:"Se agrego la Oportunidad de Mejora correctamente"
                    })
                    setActualizar(!actualizar);
                    setNumeroOportunidadNuevo("");
                    setDescripcionOportunidadNuevo("");
                    setNormaOportunidadNuevo("");
                }else{
                    Toast.fire({
                        icon:"error",
                        title:"Error al Agregar la Oportunidad de Mejora",
                        text:"No se pudo agregar la Oportunidad de Mejora"
                    })
                }
            })
    }

    const eliminarOportunidad = (id:string)=>{
        Confirm.fire({
            icon:"question",
            title:"Eliminar Oportunidad de Mejora",
            text:"¿Desea Eliminar la Oportunidad de Mejora Seleccionada?",
            confirmButtonText:"Eliminar",
            confirmButtonColor:"red"
        }).then(response=>{
            if(response.value === true){

                let init = {
                    method: "DELETE",
                    body: JSON.stringify({
                        Id: id
                    }),
                    header:{
                        "Content-Type":"aplication/json"
                    }
                };
                fetch(API_AUDITORIAS + "/Oportunidades",init)
                    .then(response=>response.json())
                    .catch(err=>console.log(err))
                    .then((data)=>{
                        if(data?.Mensaje ==="Ok"){
                            Toast.fire({
                                icon:"success",
                                title:"Oportunidad de Mejora Eliminada",
                                text:"Se elimino la Oportunidad de Mejora correctamente"
                            })
                            setActualizar(!actualizar);
                            setNumeroOportunidadNuevo("");
                            setDescripcionOportunidadNuevo("");
                            setNormaOportunidadNuevo("");
                        }else{
                            Toast.fire({
                                icon:"error",
                                title:"Error al Eliminar la Oportunidad de Mejora",
                                text:"No se pudo eliminar la Oportunidad de Mejora"
                            })
                        }
                    })


            }
        })
    }

    //* OBSERVACIONES */
   
    const nuevaObservacion = ()=>{
        let obs = {
            Id:"",
            Id_informe: "",
            Numero: "",
            Descripcion: "",
            Norma:""
        }
        setObservaciones([...observaciones,obs]);
    }

    const cancelarNuevaObservacion= ()=>{
        setNumeroObservacionNuevo("");
        setDescripcionObservacionNuevo("");
        setNormaObservacionNuevo("");
        setObservaciones(observaciones.slice(0,observaciones.length-1));
    }

    const guardarObservacion= ()=>{
        let init = {
            method: "POST",
            body: JSON.stringify({
                Id_informe: informe?.Id,
                Numero: numeroObservacionNuevo,
                Descripcion: descripcionObservacionNuevo,
                Norma: normaObservacionNuevo
            }),
            header:{
                "Content-Type":"aplication/json"
            }
        };
        fetch(API_AUDITORIAS + "/Observaciones",init)
            .then(response=>response.json())
            .catch(err=>console.log(err))
            .then((data)=>{
                if(data?.Id){
                    Toast.fire({
                        icon:"success",
                        title:"Observación Agregada",
                        text:"Se agrego la Observación correctamente"
                    })
                    setActualizar(!actualizar);
                    setNumeroObservacionNuevo("");
                    setDescripcionObservacionNuevo("");
                    setNormaObservacionNuevo("");
                }else{
                    Toast.fire({
                        icon:"error",
                        title:"Error al Agregar la Observación",
                        text:"No se pudo agregar la Observación"
                    })
                }
            })
    }

    const eliminarObservacion = (id:string)=>{
        Confirm.fire({
            icon:"question",
            title:"Eliminar Observación",
            text:"¿Desea Eliminar la Observación Seleccionada?",
            confirmButtonText:"Eliminar",
            confirmButtonColor:"red"
        }).then(response=>{
            if(response.value === true){

                let init = {
                    method: "DELETE",
                    body: JSON.stringify({
                        Id: id
                    }),
                    header:{
                        "Content-Type":"aplication/json"
                    }
                };
                fetch(API_AUDITORIAS + "/Observaciones",init)
                    .then(response=>response.json())
                    .catch(err=>console.log(err))
                    .then((data)=>{
                        if(data?.Mensaje ==="Ok"){
                            Toast.fire({
                                icon:"success",
                                title:"Observación Eliminada",
                                text:"Se elimino la Observación correctamente"
                            })
                            setActualizar(!actualizar);
                            setNumeroObservacionNuevo("");
                            setDescripcionObservacionNuevo("");
                            setNormaObservacionNuevo("");
                        }else{
                            Toast.fire({
                                icon:"error",
                                title:"Error al Eliminar la Observación",
                                text:"No se pudo eliminar la Observación"
                            })
                        }
                    })


            }
        })
    }


    //* NO CONFORMIDADES */


    const nuevaNoConformidad = ()=>{
        let noConf = {
            Id:"",
            Id_informe: "",
            Numero: "",
            Descripcion: "",
            Norma:""
        }
        setNoConformidades([...noConformidades,noConf]);
    }

    const cancelarNuevaNoConformidad = ()=>{
        setNumeroNoConformidadNuevo("");
        setDescripcionNoConformidadNuevo("");
        setNormaNoConformidadNuevo("");
        setNoConformidades(noConformidades.slice(0,noConformidades.length-1));
    }

    const guardarNoConformidad = ()=>{
        let init = {
            method: "POST",
            body: JSON.stringify({
                Id_informe: informe?.Id,
                Numero: numeroNoConformidadNuevo,
                Descripcion: descripcionNoConformidadNuevo,
                Norma: normaNoConformidadNuevo
            }),
            header:{
                "Content-Type":"aplication/json"
            }
        };
        fetch(API_AUDITORIAS + "/No-Conformidades",init)
            .then(response=>response.json())
            .catch(err=>console.log(err))
            .then((data)=>{
                if(data?.Id){
                    Toast.fire({
                        icon:"success",
                        title:"No Conformidad Agregada",
                        text:"Se agrego la No Conformidad correctamente"
                    })
                    setActualizar(!actualizar);
                    setNumeroNoConformidadNuevo("");
                    setDescripcionNoConformidadNuevo("");
                    setNormaNoConformidadNuevo("");
                }else{
                    Toast.fire({
                        icon:"error",
                        title:"Error al Agregar la Fortaleza",
                        text:"No se pudo agregar la Fortaleza"
                    })
                }
            })
    }

    const eliminarNoConformidad = (id:string)=>{
        Confirm.fire({
            icon:"question",
            title:"Eliminar No Conformidad",
            text:"¿Desea Eliminar la No Conformidad Seleccionada?",
            confirmButtonText:"Eliminar",
            confirmButtonColor:"red"
        }).then(response=>{
            if(response.value === true){

                let init = {
                    method: "DELETE",
                    body: JSON.stringify({
                        Id: id
                    }),
                    header:{
                        "Content-Type":"aplication/json"
                    }
                };
                fetch(API_AUDITORIAS + "/No-Conformidades",init)
                    .then(response=>response.json())
                    .catch(err=>console.log(err))
                    .then((data)=>{
                        if(data?.Mensaje ==="Ok"){
                            Toast.fire({
                                icon:"success",
                                title:"No Conformidad Eliminada",
                                text:"Se elimino la No Conformidad correctamente"
                            })
                            setActualizar(!actualizar);
                            setNumeroNoConformidadNuevo("");
                            setDescripcionNoConformidadNuevo("");
                            setNormaNoConformidadNuevo("");
                        }else{
                            Toast.fire({
                                icon:"error",
                                title:"Error al Eliminar la No Conformidad",
                                text:"No se pudo eliminar la No Conformidad"
                            })
                        }
                    })


            }
        })
    }




    return(
        <div className="m-1">
            <h3 className="titulo">Informe de Auditoría Interna</h3>
            <div
                className="row justify-content-center align-items-top g-2"
            >
                <div className="col-4">
                    <div className="mb-3">
                        <label htmlFor="" className="form-label">Organización</label>
                        <textarea
                            value={organizacion}
                            disabled={user.Auditoria!=="2"?true:false}
                            title={organizacion===""?"Doble click para cargar el lugar del informe anterior":""}
                            className="form-control"
                            rows={2}
                            placeholder={informe?.Organizacion?.slice(0,20)+"..."}
                            onDoubleClick={()=>setOrganizacion(informe?informe.Organizacion.toString():"")}
                            onChange={(e)=>setOrganizacion(e.target.value)}
                        >
                        </textarea>
                        {
                            user.Auditoria==="2"?<>
                            <small id="helpId" className="form-text text-muted ocultar-al-imprimir">Nombre de la Organización donde se realizará la auditoría</small>
                            </>
                            :
                            <div></div>
                        }
                    </div>
                    
                </div>
                <div className="col-4">
                    <div className="mb-3">
                        <label htmlFor="" className="form-label">Dirección</label>
                        <textarea
                            value={direccion}
                            disabled={user.Auditoria!=="2"?true:false}
                            title={direccion===""?"Doble click para cargar el lugar del informe anterior":""}
                            className="form-control"
                            rows={2}
                            placeholder={informe?.Direccion?.slice(0,20)+"..."}
                            onDoubleClick={()=>setDireccion(informe?informe.Direccion.toString():"")}
                            onChange={(e)=>setDireccion(e.target.value)}
                        >
                        </textarea>
                        {
                            user.Auditoria==="2"?<>
                            <small id="helpId" className="form-text text-muted ocultar-al-imprimir">Dirección donde se realizará la auditoría</small>
                            </>
                            :
                            <div></div>
                        }
                    </div>
                    
                </div>
                <div className="col-2">
                    <div className="mb-3">
                        <label htmlFor="fecha-informe" className="form-label">Fecha</label>
                        <input
                            value={fecha}
                            disabled={user.Auditoria!=="2"?true:false}
                            type="date"
                            className="form-control"
                            name="fecha-informe"
                            id="fecha-informe"
                            aria-describedby="helpId"
                            onChange={(e)=>setFecha(e.target.value)}
                        />
                        {
                            user.Auditoria==="2"?
                            <small id="helpId" className="form-text text-muted ocultar-al-imprimir">Fecha de inicio de la auditoría</small>
                            :
                            <div></div>
                        }
                    </div>
                </div>
                <div className="col-2">
                    <div className="mb-3">
                        <label htmlFor="nro-auditoria" className="form-label">Auditoría Nº</label>
                        <input
                            value={numero_auditoria}
                            disabled={user.Auditoria!=="2"?true:false}
                            type="text"
                            className="form-control"
                            name="nro-auditoria"
                            id="nro-auditoria"
                            aria-describedby="helpId"
                            onChange={(e)=>setNumero_auditoria(e.target.value)}
                        />
                        {
                            user.Auditoria==="2"?
                            <small id="helpId" className="form-text text-muted ocultar-al-imprimir">Número correspondiente a la auditoría</small>
                            :
                            <div></div>
                        }
                    </div>
                </div>
            </div>
            
            <div
                className="row justify-content-center align-items-top g-2"
            >
                <div className="col">
                    <div className="mb-3">
                        <label htmlFor="" className="form-label">Objetivo</label>
                        <textarea 
                            disabled={user.Auditoria!=="2"?true:false}
                            className="form-control" 
                            name="" 
                            id="" 
                            rows={3} 
                            value={objetivo}
                            title={objetivo===""?"Doble click para cargar el objetivo del informe anterior":""}
                            aria-describedby="helpId"
                            placeholder={informe?.Objetivo?.slice(0,20)+"..."}
                            onDoubleClick={()=>setObjetivo(informe?informe.Objetivo.toString():"")}
                            onChange={(e)=>setObjetivo(e.target.value)}
                        ></textarea>
                        {
                            user.Auditoria==="2"?
                            <small id="helpId" className="form-text text-muted ocultar-al-imprimir">Objetivos que se pretenden lograr durante la auditoría</small>
                            :
                            <div></div>
                        }
                    </div>
                    
                </div>
                <div className="col">
                    <div className="mb-3">
                        <label htmlFor="alcance-informe" className="form-label">Alcance</label>
                        <textarea 
                            disabled={user.Auditoria!=="2"?true:false}
                            className="form-control" 
                            name="alcance-informe" 
                            id="alcance-informe" 
                            rows={3} 
                            value={alcance}
                            title={alcance===""?"Doble click para cargar el alcance del informe anterior":""}
                            aria-describedby="helpId"
                            placeholder={informe?.Alcance?.slice(0,20)+"..."}
                            onDoubleClick={()=>setAlcance(informe?informe.Alcance.toString():"")}
                            onChange={(e)=>setAlcance(e.target.value)}
                        ></textarea>
                        {
                            user.Auditoria==="2"?
                            <small id="helpId" className="form-text text-muted ocultar-al-imprimir">Definir el alcance que comprende la auditoría</small>
                            :
                            <div></div>
                        }
                    </div>
                    
                </div>
            </div>

            
                    <div className="mb-3">
                        <label htmlFor="criterios-informe" className="form-label">Criterios</label>
                        <textarea 
                            disabled={user.Auditoria!=="2"?true:false}
                            className="form-control" 
                            name="criterios-informe" 
                            id="criterios-informe" 
                            rows={3} 
                            value={criterios}
                            title={criterios===""?"Doble click para cargar los criterios del informe anterior":""}
                            aria-describedby="helpId"
                            placeholder={informe?.Criterios?.slice(0,20)+"..."}
                            onDoubleClick={()=>setCriterios(informe?informe.Criterios.toString():"")}
                            onChange={(e)=>setCriterios(e.target.value)}
                        ></textarea>
                        {
                            user.Auditoria==="2"?
                            <small id="helpId" className="form-text text-muted ocultar-al-imprimir">Definir los criterios que se implementarán durante la auditoría</small>
                            :
                            <div></div>
                        }
                    </div>

            <div
                className="row justify-content-center align-items-start g-2"
            >
                {
                    user.Auditoria!=="0"?
                    <div className="col">
                        <div
                            className="table-responsive"
                        >
                            <h6>Equipo Auditor</h6>
                            <table
                                className="table table-striped table-hover table-borderless table-secondary align-top"
                            >
                                <thead className="table-success">
                                    <tr>
                                        <th>Apellido, Nombre</th>
                                        <th>Función</th>
                                        <th>
                                            {
                                                auditores[auditores.length-1]?.Id!==""?
                                                informe?.Id!==""?
                                                <button 
                                                    disabled={user.Auditoria!=="2"?true:false}
                                                    className="btn btn-sm btn-outline-secondary ocultar-al-imprimir"
                                                    title="Agregar Auditor"
                                                    onClick={nuevoAuditor}
                                                ><i className="bi bi-person-plus"></i>
                                                </button>
                                                :
                                                <div></div>
                                                :
                                                <div></div>
                                            }
                                            
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="table-group-divider">
                                    {
                                        auditores.map((auditor,key)=>(
                                            auditor.Id===""?
                                            <tr className="table-danger" key={key}>
                                                <td >
                                                    <input type="text" className="form-control" value={nombreNuevoAuditor} onChange={(e)=>setNombreNuevoAuditor(e.target.value)}/>
                                                </td>
                                                <td >
                                                    <input type="text" className="form-control" value={funcionNuevoAuditor} onChange={(e)=>setFuncionNuevoAuditor(e.target.value)}/>
                                                </td>
                                                <td >
                                                    <div className="d-flex justify-content-center align-items-center">
                                                        <button 
                                                            className="btn btn-sm btn-outline-success mx-1" 
                                                            onClick={guardarAuditor} 
                                                            disabled={user.Auditoria!=="2"?true:false}
                                                        >
                                                            <i className="bi bi-floppy2-fill"></i>
                                                        </button>
                                                        <button 
                                                            className="btn btn-sm btn-outline-danger mx-1" 
                                                            onClick={cancelarNuevoAuditor}
                                                            disabled={user.Auditoria!=="2"?true:false}
                                                        >
                                                            <i className="bi bi-trash-fill"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                            :
                                            <tr className="table-secondary" key={key} >
                                                <td >{auditor.Nombre}</td>
                                                <td >{auditor.Funcion}</td>
                                                <td >
                                                    <button 
                                                        className="btn btn-sm btn-outline-danger mx-1 ocultar-al-imprimir" 
                                                        onClick={()=>eliminarAuditor(auditor.Id.toString())}
                                                        disabled={user.Auditoria!=="2"?true:false}
                                                    >
                                                        <i className="bi bi-trash-fill"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                                <tfoot>
                                    
                                </tfoot>
                            </table>
                        </div>
                        
                    </div>
                    :
                    <div></div>
                }

                {
                    user.Auditoria!=="0"?
                    <div className="col">
                        <div
                            className="table-responsive"
                        >
                            <h6>Personal Interviniente</h6>
                            <table
                                className="table table-striped table-hover table-borderless table-secondary align-top"
                            >
                                <thead className="table-success">
                                    <tr>
                                        <th>Apellido, Nombre</th>
                                        <th>Puesto</th>
                                        <th>
                                            {
                                                personal[personal.length-1]?.Id!==""?
                                                informe?.Id!==""?
                                                <button 
                                                    disabled={user.Auditoria!=="2"?true:false}
                                                    className="btn btn-sm btn-outline-secondary ocultar-al-imprimir"
                                                    title="Agregar Personal"
                                                    onClick={nuevoPersonal}
                                                ><i className="bi bi-person-plus"></i>
                                                </button>
                                                :
                                                <div></div>
                                                :
                                                <div></div>
                                            }
                                            
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="table-group-divider">
                                    {
                                        personal.map((persona,key)=>(
                                            persona.Id===""?
                                            <tr className="table-danger" key={key}>
                                                <td >
                                                    <input type="text" className="form-control" value={nombreNuevoPersonal} onChange={(e)=>setNombreNuevoPersonal(e.target.value)}/>
                                                </td>
                                                <td >
                                                    <input type="text" className="form-control" value={puestoNuevoPersonal} onChange={(e)=>setPuestoNuevoPersonal(e.target.value)}/>
                                                </td>
                                                <td >
                                                    <div className="d-flex justify-content-center align-items-center">
                                                        <button 
                                                            className="btn btn-sm btn-outline-success mx-1" 
                                                            onClick={guardarPersonal} 
                                                            disabled={user.Auditoria!=="2"?true:false}
                                                        >
                                                            <i className="bi bi-floppy2-fill"></i>
                                                        </button>
                                                        <button 
                                                            className="btn btn-sm btn-outline-danger mx-1" 
                                                            onClick={cancelarNuevoPersonal}
                                                            disabled={user.Auditoria!=="2"?true:false}
                                                        >
                                                            <i className="bi bi-trash-fill"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                            :
                                            <tr className="table-secondary" key={key}>
                                                <td >{persona.Nombre}</td>
                                                <td >{persona.Puesto}</td>
                                                <td >
                                                    <button 
                                                        className="btn btn-sm btn-outline-danger mx-1 ocultar-al-imprimir" 
                                                        onClick={()=>eliminarPersonal(persona.Id.toString())}
                                                        disabled={user.Auditoria!=="2"?true:false}
                                                    >
                                                        <i className="bi bi-trash-fill"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                                <tfoot>
                                    
                                </tfoot>
                            </table>
                        </div>
                        
                    </div>
                    :
                    <div></div>
                }
                
            </div>

            <div>
                <h5 className="titulo">Fortalezas</h5>
                <div
                    className="table-responsive"
                >
                    <table
                        className="table table-striped table-hover table-borderless table-success align-top"
                    >
                        <thead className="table-success">
                            <tr>
                                <th>Nro</th>
                                <th>Descripción</th>
                                <th>Requisito ISO 9001:2015</th>
                                <th>
                                    {
                                        fortalezas[fortalezas.length-1]?.Id===""?
                                        <div></div>
                                        :
                                        informe?.Id===""?
                                        <div></div>
                                        :
                                        <button 
                                            className="btn btn-sm btn-outline-secondary ocultar-al-imprimir"
                                            disabled={user.Auditoria==="2"?false:true}
                                            title="Agregar Fortaleza"
                                            onClick={nuevaFortaleza}
                                        >
                                            <i className="bi bi-file-earmark-plus"></i>
                                        </button>
                                    }
                                </th>
                            </tr>
                        </thead>
                        <tbody className="table-group-divider">
                            {
                                fortalezas.map((fortaleza,key)=>(
                                    fortaleza.Id===""?
                                    <tr 
                                        key={key}
                                        className="table-light"
                                    >
                                        <td>
                                            <input 
                                                type="text"  
                                                className="form-control"
                                                value={numeroFortalezaNuevo}
                                                onChange={(e)=>setNumeroFortalezaNuevo(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input 
                                                type="text" 
                                                className="form-control"
                                                value={descripcionFortalezaNuevo}
                                                onChange={(e)=>setDescripcionFortalezaNuevo(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input 
                                                type="text"
                                                className="form-control"
                                                value={normaFortalezaNuevo}
                                                onChange={(e)=>setNormaFortalezaNuevo(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <div className="d-flex justify-content-center align-items-center">
                                                <button 
                                                    className="btn btn-sm btn-outline-success mx-1" 
                                                    disabled={user.Auditoria!=="2"?true:false}
                                                    onClick={guardarFortaleza}
                                                >
                                                    <i className="bi bi-floppy2-fill"></i>
                                                </button>
                                                <button 
                                                    className="btn btn-sm btn-outline-danger mx-1" 
                                                    disabled={user.Auditoria!=="2"?true:false}
                                                    onClick={cancelarNuevaFortaleza}
                                                >
                                                    <i className="bi bi-trash-fill"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    :
                                    <tr
                                        key={key}
                                        className="table-light"
                                    >
                                        <td>{fortaleza.Numero}</td>
                                        <td>{fortaleza.Descripcion}</td>
                                        <td>{fortaleza.Norma}</td>
                                        <td>
                                            <button 
                                                className="btn btn-sm btn-outline-danger mx-1 ocultar-al-imprimir" 
                                                onClick={()=>eliminarFortaleza(fortaleza.Id.toString())}
                                                disabled={user.Auditoria!=="2"?true:false}
                                            >
                                                <i className="bi bi-trash-fill"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                        <tfoot>
                            
                        </tfoot>
                    </table>
                </div>

                
                <h5 className="titulo">Oportunidad de Mejora</h5>
                <div
                    className="table-responsive"
                >
                    <table
                        className="table table-striped table-hover table-borderless table-primary align-top"
                    >
                        <thead className="table-primary">
                            <tr>
                                <th>Nro</th>
                                <th>Descripción</th>
                                <th>Requisito ISO 9001:2015</th>
                                <th>
                                    {
                                        
                                        oportunidades[oportunidades.length-1]?.Id===""?
                                        <div></div>
                                        :
                                        informe?.Id===""?
                                        <div></div>
                                        :
                                        <button 
                                            className="btn btn-sm btn-outline-secondary ocultar-al-imprimir"
                                            disabled={user.Auditoria==="2"?false:true}
                                            title="Agergar Oportunid de Mejora"
                                            onClick={nuevaOportunidad}
                                        >
                                            <i className="bi bi-file-earmark-plus"></i>
                                        </button>
                                    }
                                </th>
                            </tr>
                        </thead>
                        <tbody className="table-group-divider">
                            {
                                oportunidades.map((oportunidad,key)=>(
                                    oportunidad.Id===""?
                                    <tr
                                        className="table-light"
                                        key={key}
                                    >
                                        <td>
                                            <input 
                                                type="text"
                                                className="form-control"
                                                value={numeroOportunidadNuevo}
                                                onChange={(e)=>setNumeroOportunidadNuevo(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input 
                                                type="text"
                                                className="form-control"
                                                value={descripcionOportunidadNuevo}
                                                onChange={(e)=>setDescripcionOportunidadNuevo(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input 
                                                type="text" 
                                                className="form-control"
                                                value={normaOportunidadNuevo}
                                                onChange={(e)=>setNormaOportunidadNuevo(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <div className="d-flex justify-content-center align-items-center">
                                                <button 
                                                    className="btn btn-sm btn-outline-success mx-1" 
                                                    disabled={user.Auditoria!=="2"?true:false}
                                                    onClick={guardarOportunidad}
                                                >
                                                    <i className="bi bi-floppy2-fill"></i>
                                                </button>
                                                <button 
                                                    className="btn btn-sm btn-outline-danger mx-1" 
                                                    disabled={user.Auditoria!=="2"?true:false}
                                                    onClick={cancelarNuevaOportunidad}
                                                >
                                                    <i className="bi bi-trash-fill"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    :
                                    <tr
                                        className="table-light"
                                        key={key}
                                    >
                                        <td>{ oportunidad.Numero }</td>
                                        <td>{oportunidad.Descripcion}</td>
                                        <td>{oportunidad.Norma}</td>
                                        <td>
                                            <button 
                                                className="btn btn-sm btn-outline-danger mx-1 ocultar-al-imprimir" 
                                                onClick={()=>eliminarOportunidad(oportunidad.Id.toString())}
                                                disabled={user.Auditoria!=="2"?true:false}
                                            >
                                                <i className="bi bi-trash-fill"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            }
                            
                        </tbody>
                        <tfoot>
                            
                        </tfoot>
                    </table>
                </div>

                
                <h5 className="titulo">Observaciones</h5>
                <div
                    className="table-responsive"
                >
                    <table
                        className="table table-striped table-hover table-borderless table-warning align-top"
                    >
                        <thead className="table-warning">
                            <tr>
                                <th>Nro</th>
                                <th>Descripción</th>
                                <th>Requisito ISO 9001:2015</th>
                                <th>
                                    {
                                        
                                        observaciones[observaciones.length-1]?.Id===""?
                                        <div></div>
                                        :
                                        informe?.Id===""?
                                        <div></div>
                                        :
                                        <button 
                                            className="btn btn-sm btn-outline-secondary ocultar-al-imprimir"
                                            disabled={user.Auditoria==="2"?false:true}
                                            title="Agregar Observación"
                                            onClick={nuevaObservacion}
                                        >
                                            <i className="bi bi-file-earmark-plus"></i>
                                        </button>
                                    }
                                </th>
                            </tr>
                        </thead>
                        <tbody className="table-group-divider">
                            {
                                observaciones.map((observacion,key)=>(
                                    observacion.Id===""?
                                    <tr
                                        key={key}
                                        className="table-light"
                                    >
                                        <td>
                                            <input 
                                                type="text"
                                                className="form-control"
                                                value={numeroObservacionNuevo}
                                                onChange={(e)=>setNumeroObservacionNuevo(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input 
                                                type="text" 
                                                className="form-control"
                                                value={descripcionObservacionNuevo}
                                                onChange={(e)=>setDescripcionObservacionNuevo(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input 
                                                type="text"
                                                className="form-control"
                                                value={normaObservacionNuevo}
                                                onChange={(e)=>setNormaObservacionNuevo(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <div className="d-flex justify-content-center align-items-center">
                                                <button 
                                                    className="btn btn-sm btn-outline-success mx-1" 
                                                    disabled={user.Auditoria!=="2"?true:false}
                                                    onClick={guardarObservacion}
                                                >
                                                    <i className="bi bi-floppy2-fill"></i>
                                                </button>
                                                <button 
                                                    className="btn btn-sm btn-outline-danger mx-1" 
                                                    disabled={user.Auditoria!=="2"?true:false}
                                                    onClick={cancelarNuevaObservacion}
                                                >
                                                    <i className="bi bi-trash-fill"></i>
                                                </button>
                                            </div>
                                        </td>

                                    </tr>
                                    :
                                    <tr
                                        key={key}
                                        className="table-light"
                                    >
                                        <td>{observacion.Numero}</td>
                                        <td>{observacion.Descripcion}</td>
                                        <td>{observacion.Norma}</td>
                                        <td>
                                            <button 
                                                className="btn btn-sm btn-outline-danger mx-1 ocultar-al-imprimir" 
                                                onClick={()=>eliminarObservacion(observacion.Id.toString())}
                                                disabled={user.Auditoria!=="2"?true:false}
                                            >
                                                <i className="bi bi-trash-fill"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                        <tfoot>
                            
                        </tfoot>
                    </table>
                </div>

                
                <h5 className="titulo">No Conformidades</h5>
                <div
                    className="table-responsive"
                >
                    <table
                        className="table table-striped table-hover table-borderless table-danger align-top"
                    >
                        <thead className="table-danger">
                            <tr>
                                <th>Nro</th>
                                <th>Descripción</th>
                                <th>Requisito ISO 9001:2015</th>
                                <th>
                                    {
                                        
                                        noConformidades[noConformidades.length-1]?.Id===""?
                                        <div></div>
                                        :
                                        informe?.Id===""?
                                        <div></div>
                                        :
                                        <button 
                                            className="btn btn-sm btn-outline-secondary ocultar-al-imprimir"
                                            disabled={user.Auditoria==="2"?false:true}
                                            title="Agergar No Conformidad"
                                            onClick={nuevaNoConformidad}
                                        >
                                            <i className="bi bi-file-earmark-plus"></i>
                                        </button>
                                    }
                                </th>
                            </tr>
                        </thead>
                        <tbody className="table-group-divider">
                            {
                                noConformidades.map((noConformidad,key)=>(
                                    noConformidad.Id===""?
                                    <tr
                                        key={key}
                                        className="table-light"
                                    >
                                        <td>
                                            <input 
                                                type="text" 
                                                className="form-control"
                                                value={numeroNoConformidadNuevo}
                                                onChange={(e)=>setNumeroNoConformidadNuevo(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input 
                                                type="text" 
                                                className="form-control"
                                                value={descripcionNoConformidadNuevo}
                                                onChange={(e)=>setDescripcionNoConformidadNuevo(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input 
                                                type="text" 
                                                className="form-control"
                                                value={normaNoConformidadNuevo}
                                                onChange={(e)=>setNormaNoConformidadNuevo(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <div className="d-flex justify-content-center align-items-center">
                                                <button 
                                                    className="btn btn-sm btn-outline-success mx-1" 
                                                    disabled={user.Auditoria!=="2"?true:false}
                                                    onClick={guardarNoConformidad}
                                                >
                                                    <i className="bi bi-floppy2-fill"></i>
                                                </button>
                                                <button 
                                                    className="btn btn-sm btn-outline-danger mx-1" 
                                                    disabled={user.Auditoria!=="2"?true:false}
                                                    onClick={cancelarNuevaNoConformidad}
                                                >
                                                    <i className="bi bi-trash-fill"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    :
                                    <tr
                                        key={key}
                                        className="table-light"
                                    >
                                        <td>{noConformidad.Numero}</td>
                                        <td>{noConformidad.Descripcion}</td>
                                        <td>{noConformidad.Norma}</td>
                                        <td>
                                            <button 
                                                className="btn btn-sm btn-outline-danger mx-1 ocultar-al-imprimir" 
                                                onClick={()=>eliminarNoConformidad(noConformidad.Id.toString())}
                                                disabled={user.Auditoria!=="2"?true:false}
                                            >
                                                <i className="bi bi-trash-fill"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                        <tfoot>
                            
                        </tfoot>
                    </table>
                </div>
                
            </div>

            <div>
                <div className="mb-3">
                    <h5 className="titulo mt-5">Conclusiones de la Auditoría:</h5>
                    <textarea
                        className="form-control" 
                        rows={5}
                        value={conclusion}
                        onChange={(e)=>setConclusion(e.target.value)}
                    ></textarea>
                </div>
                
            </div>

            <hr />
            <div className="d-flex justify-content-center align-items-center mt-2">
                {
                    informe?.Id===""?
                    <button 
                        className="btn btn-outline-success ocultar-al-imprimir" 
                        onClick={guardarInforme}
                        disabled={user.Auditoria!=="2"?true:false}
                    >
                        Crear Informe de Auditoría
                    </button>
                    :
                    <button 
                        className="btn btn-outline-warning ocultar-al-imprimir" 
                        onClick={guardarInforme}
                        disabled={user.Auditoria!=="2"?true:false}
                    >
                        Actualizar Informe de Auditoría
                    </button>
                }
            </div>
            <hr className="ocultar-al-imprimir"/>
            {
                informe?.Id!==""?
                    <div
                        className="alert alert-danger ocultar-al-imprimir"
                        role="alert"
                    >
                        <h4 className="alert-heading">Eliminar Informe de Auditoría Interna Nº {informe?.Nro_auditoria}</h4>
                        <p>Al eliminar el informe de auditoría se borrarán todos los datos relacionados de las bases de datos</p>
                        <hr />
                        <button 
                            className="btn btn-sm btn-outline-danger"
                            disabled={user.Auditoria!=="2"?true:false} 
                            onClick={informe?()=>eliminarInforme(informe.Id.toString()):()=>{}}
                        >
                            Eliminar Informe
                        </button>
                    </div>
                :
                <div></div>
            }
            

        </div>
    )
}